import { OnInit, OnDestroy, Component, Optional, Inject } from '@angular/core';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { PershingTranslationService } from '@pershing/pershing-core';
import { Router } from '@angular/router';

declare let dojoApp: any;

@Component({
    selector: 'dojo-financial-plan-overview',
    templateUrl: './dojo-financial-plan-overview.component.html'
})
export class DojoFinancialPlanOverviewComponent implements OnInit, OnDestroy {
    nxiRestServiceUrl: any;
    isAdaTheme: boolean = false;
    title: string;
    showGotoLink: boolean = true;
    removeFinancialPlan: boolean;
    topicHandle: any = null;
    constructor(private nxiRestService: NxiRestService,
                @Optional() @Inject('AppSettings') appSettings: any,
                private translationService: PershingTranslationService,
                private router: Router) {
            this.nxiRestServiceUrl = this.nxiRestService.serviceUrl;
            if (this.router.url.indexOf('financialplanning') > -1) {
                this.showGotoLink = false;
            }
            this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
            if (appSettings.themeType && appSettings.themeType === 'ada') {
                this.isAdaTheme = true;
                this.title = 'dojo-financial-plan-overview';
            }
    }

    ngOnInit() {
        this.nxiRestService.renderFinancialPlanning().subscribe(
            (response: any) => {
                this.removeFinancialPlan = (response.removeFinancialPlan === 'Y');
                if (!this.removeFinancialPlan && dojoApp) {
                    if (sessionStorage.getItem('rmvFinPlan')) {
                        sessionStorage.removeItem('rmvFinPlan');
                    }
                    this.nxiRestService.renderFinancialPlanningResp('/portfolio/financial-plan').subscribe(
                        (resp: any) => {
                            if (!resp) {
                                sessionStorage.setItem('rmvFinPlan', 'Y');
                            }
                        }, (error) => {
                            sessionStorage.setItem('rmvFinPlan', 'ADA_Y');
                        }
                    );
                    let params = { storeUrl: this.nxiRestServiceUrl + '/portfolio/financial-plan' };
                    dojoApp.renderMGP(params);
                }
                if (this.removeFinancialPlan) {
                    if (window['require']) {
                        let topic = window['require']('dojo/topic');
                        topic.publish('/removeFinancialPlan');
                        this.topicHandle = topic.subscribe('/checkFinancialPlan', () => {
                            topic.publish('/removeFinancialPlan');
                        });
                    }
                    document.dispatchEvent(new CustomEvent('removeFromNavigation', {detail: {
                        navLevel: 2,
                        mainMenu: 'tools',
                        secondLevelMenu: 'financialplanning'
                    }}));
                    sessionStorage.setItem('rmvFinPlan', response.removeFinancialPlan);
                }
            }
        );
    }

    goToFinancialTab(): void {
        document.dispatchEvent(new CustomEvent('portal.gotoview', {
            detail: {
                'gotoPage': '/nxi/tools/financialplanning'
            }
        }));
    }

    ngOnDestroy(): void {
        if (dojoApp) {
            dojoApp.destroyMGP('financialPlanWidget');
        }
        if (this.topicHandle) {
            this.topicHandle.remove();
        }
    }
}
